import {
  WORKBOOK_PREVIEW_ROWS,
  WORKBOOK_SOURCE_SAMPLE_MAX_ROWS,
  type WorkbookSample,
} from '@erp/shared-types';

/** How many rows the preview can show. */
export const PREVIEW_ROW_CHOICES = [
  WORKBOOK_PREVIEW_ROWS,
  500,
  WORKBOOK_SOURCE_SAMPLE_MAX_ROWS,
] as const;

/** Whether the preview's plain leading rows answer the choice, so no sample is read. */
export function needsSourceSample(sample: WorkbookSample, rows: number) {
  return sample.method !== 'first' || rows > WORKBOOK_PREVIEW_ROWS;
}
